import React, { useState, useRef } from "react";
import axios from "axios";

const API_BASE = "/api";

function Home() {
  const [greetingUrl, setGreetingUrl] = useState(null);
  const [replyUrl, setReplyUrl] = useState(null);
  const [recording, setRecording] = useState(false);
  const [callStarted, setCallStarted] = useState(false);
  const [message, setMessage] = useState("");
  const videoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const initiateCall = async () => {
    try {
      console.log("Calling API:", `${API_BASE}/initiate-call`);
      const res = await axios.post(`${API_BASE}/initiate-call`);
      console.log("API Response:", res.data);
      setGreetingUrl(res.data.greeting_url);
      setMessage(res.data.message);
      setCallStarted(true);
    } catch (error) {
      console.error("Error initiating call:", error);
      alert("Error: " + (error.response?.data?.message || error.message));
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      videoRef.current.srcObject = stream;
      videoRef.current.play();

      const mediaRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: "video/webm" });
        const formData = new FormData();
        formData.append("video", blob, "reply.webm");

        const res = await axios.post(`${API_BASE}/upload-reply`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        setReplyUrl(res.data.url);
        chunksRef.current = [];
      };

      mediaRecorder.start();
      setRecording(true);
    } catch (error) {
      console.error("Error starting recording:", error);
      alert("Could not access camera/microphone: " + error.message);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    
    // Stop all tracks (camera and microphone)
    const stream = videoRef.current.srcObject;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
    
    setRecording(false);
  };

  return (
    <div className="App">
      <h1>Hermes Echo Demo</h1>
      {!callStarted && <button onClick={initiateCall}>📞 Start Call</button>}

      {callStarted && (
        <div>
          {greetingUrl ? (
            <>
              <h2>Receiver Greeting</h2>
              <video src={greetingUrl} controls autoPlay width="480" />
            </>
          ) : (
            <div>
              <h2>No Greeting Video</h2>
              <p style={{color: "orange"}}>{message}</p>
            </div>
          )}
          <br />
          {!recording && <button onClick={startRecording}>🎥 Record Reply</button>}
          {recording && <button onClick={stopRecording}>⏹ Stop Recording</button>}
        </div>
      )}

      {replyUrl && (
        <div>
          <h2>Your Reply (uploaded)</h2>
          <video src={replyUrl} controls width="480" />
        </div>
      )}
      <video ref={videoRef} style={{display: recording ? "block" : "none", margin: "20px auto"}} width="480" />
    </div>
  );
}

export default Home;
